import { useEffect, useState } from "react";
import { useEditState } from "../EditContext";
import PanoEditor from "./PanoEditor";
import { Pano } from "../../../types";
import SpinnerWrapper from "../BaseComponents/SpinnerWrapper";
import { useParams } from "react-router-dom";
import { useAppState } from "../../../AppContext";

const SinglePanoPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [pano, setPano] = useState<Pano>();
  const { target, setTarget, panoRepository } = useEditState();
  const { state } = useAppState();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      setTarget(Number(id));
    }
  }, [id, setTarget]);
  
  /* Fetch metadata for panorama. */
  useEffect(() => {
    if (target) {
      setLoading(true);
      const data = state.panos.find((pano) => pano.id === target);
      setPano(data);
      setLoading(false);
    }
  }, [panoRepository, state.panos, target]);

  return (
    <SpinnerWrapper loading={loading}>
      {pano && <PanoEditor pano={pano} />}
    </SpinnerWrapper>
  );
};

export default SinglePanoPage;
